import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "demo-key",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "auth.microfb.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "microfeedback-465714",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "microfeedback-465714.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "114447222355",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:114447222355:web:demo"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firebase Functions and get a reference to the service
export const functions = getFunctions(app, 'us-central1');

// Connect to Firebase Auth emulator in development
if (import.meta.env.DEV) {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
  } catch (error) {
    console.log('Auth emulator connection failed:', error);
  }
  
  // Temporarily disabled to connect directly to production functions
  // try {
  //   connectFunctionsEmulator(functions, 'localhost', 5001);
  // } catch (error) {
  //   console.log('Functions emulator connection failed:', error);
  // }
} 